"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutObjectTaggingInput_1 = require("./PutObjectTaggingInput");
var PutObjectTaggingOutput_1 = require("./PutObjectTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutObjectTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutObjectTagging",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}?tagging"
    },
    input: {
        shape: PutObjectTaggingInput_1.PutObjectTaggingInput
    },
    output: {
        shape: PutObjectTaggingOutput_1.PutObjectTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=PutObjectTagging.js.map